export default {
  title: 'Lataa tiedosto napsauttamalla tai vetämällä se tähän',
  description: 'Tuetut muodot tällä hetkellä: .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Lataa tuontimalli',
  },
  toasts: {
    error: 'Tiedoston lataaminen epäonnistui',
  },
};
